<template>
  <div class="content">
    <div class="tab-container wallet-tabs">
      <div ref="tab" class="tab-header NavTabs">
        <div class="tab" :class="{'active': type === 'depositRecord'}" @click.prevent="changeType('depositRecord')">
          <a>{{ $t("Bao.deposit_detail") }}</a>
        </div>
        <div class="tab" :class="{'active': type === 'withdrawRecord'}" @click.prevent="changeType('withdrawRecord')">
          <a>{{ $t('Bao.withdrawal_detail_2') }}</a>
        </div>
        <div class="tab" :class="{'active': type === 'userBet'}" @click.prevent="changeType('userBet')">
          <a>{{ $t("Bao.my_game_bet") }}</a>
        </div>
        <div class="tab" :class="{'active': type === 'bonus'}" @click.prevent="changeType('bonus')">
          <a>{{ $t("Bao.bonus_detail") }}</a>
        </div>
        <div class="tab" :class="{'active': type === 'other'}" @click.prevent="changeType('other')">
          <a>{{ $t("Bao.other") }}</a>
        </div>
      </div>
      <div class="tab-content tab-bg">
        <div v-if="type === 'depositRecord' || type === 'withdrawRecord'" class="tab-inner">
          <div class="history-list">
            <div class="history-date-frame">
              <div class="history-calendar-box">
                <div class="calendar-title">
                  {{ $t("Bao.date") }}:
                </div>
                <datePicker :key="datePickerKey" v-model="dateRange" class="calendar-data" @query="oneQuery" />
              </div>
            </div>

            <deposit-history
              v-if="type === 'depositRecord'"
              :record="record"
              :loading="loading"
              :first-load="firstLoad"
              @show-history-modal="handleShowHistoryModal"
            />
            <withdrawal-history
              v-else-if="type === 'withdrawRecord'"
              :record="record"
              :loading="loading"
              :first-load="firstLoad"
              @show-history-modal="handleShowHistoryModal"
            />
          </div>

          <div class="history-list-mobile">
            <div class="history-date">
              <div class="history-date-frame">
                <div class="history-calendar-box">
                  <div class="calendar-title">
                    {{ $t("Bao.date") }}:
                  </div>
                  <datePicker :key="datePickerKey" v-model="dateRange" class="calendar-data" @query="oneQuery" />
                </div>
              </div>
            </div>
            <div v-if="record.length === 0 && !loading && !firstLoad" class="no-data">
              <i><img :src="$getThemeImagePath('no-data.png')" alt=""></i>
              <p>{{ $t('Bao.no_relevant_data_records') }}</p>
              <span>{{ $t('Bao.search_results_are_empty') }}</span>
            </div>
            <deposit-history-mobile v-else-if="type === 'depositRecord' && record.length > 0" :record="record" @show-history-modal="handleShowHistoryModal" />
            <withdrawal-history-mobile v-else-if="type === 'withdrawRecord' && record.length > 0" :record="record" @show-history-modal="handleShowHistoryModal" />
          </div>
        </div>
        <div v-if="type === 'userBet'" class="tab-inner">
          <div class="tab-container games-list-tabs">
            <div class="tab-header NavTabs sub-items">
              <div :class="{'active': beforeDay === 0}" class="tab btn btn-tertiary-2" @click="switchDay(0)">
                <a>{{ $t("Bao.today") }}</a>
              </div>
              <div :class="{'active': beforeDay === 1}" class="tab btn btn-tertiary-2" @click="switchDay(1)">
                <a>{{ $t("Bao.yesterday") }}</a>
              </div>
              <div :class="{'active': beforeDay === 2}" class="tab btn btn-tertiary-2" @click="switchDay(2)">
                <a>{{ $t("Bao.2_days_ago") }}</a>
              </div>
              <div :class="{'active': beforeDay === 3}" class="tab btn btn-tertiary-2" @click="switchDay(3)">
                <a>{{ $t("Bao.3_days_ago") }}</a>
              </div>
              <div :class="{'active': beforeDay === 4}" class="tab btn btn-tertiary-2" @click="switchDay(4)">
                <a>{{ $t("Bao.4_days_ago") }}</a>
              </div>
              <div :class="{'active': beforeDay === 5}" class="tab btn btn-tertiary-2" @click="switchDay(5)">
                <a>{{ $t("Bao.5_days_ago") }}</a>
              </div>
              <div :class="{'active': beforeDay === 6}" class="tab btn btn-tertiary-2" @click="switchDay(6)">
                <a>{{ $t("Bao.6_days_ago") }}</a>
              </div>
              <div :class="{'active': beforeDay === 7}" class="tab btn btn-tertiary-2" @click="switchDay(7)">
                <a>{{ $t("Bao.7_days_ago") }}</a>
              </div>
            </div>
            <div class="tab-content">
              <div id="games-list-tab00" class="tab-inner">
                <bet-history
                  v-if="type === 'userBet'"
                  :loading="loading"
                  :first-load="firstLoad"
                  :record="record"
                />
              </div>
            </div>
          </div>
        </div>

        <div v-if="type === 'bonus' || type === 'other'" class="row-frame g-3">
          <div class="colu colu-xl-6 flex-colu">
            <select
              v-model="selectedActionType"
              class="for-select inpType icon-select fs-14-w-700"
              @change="filterByActionType"
            >
              <option
                v-for="action in filteredActionOptions"
                :key="action.key"
                :value="action.key"
              >
                {{ $t(action.lang) }}
              </option>
            </select>
          </div>

          <div class="colu colu-xl-6 flex-colu">
            <div class="history-calendar-box">
              <div class="calendar-title">
                {{ $t("Bao.date") }}:
              </div>
              <datePicker :key="datePickerKey" v-model="dateRange" class="calendar-data" @query="oneQuery" />
            </div>
          </div>
          <other-history
            :loading="loading"
            :first-load="firstLoad"
            :record="record"
          />
        </div>
        <scroll-loader :loader-method="query" :loader-disable="!enableAutoLoad" />
      </div>
    </div>
    <transaction-history-modal
      :is-active="showHistory"
      :item="selectedItem"
      :type="type"
      @hideHistoryModal="hideHistoryModal"
    />
  </div>
</template>

<script>
import datePicker from '@/components/datePicker'
import moment from 'moment'
import { getWalletImagePath } from '@/utils/tool'
import { depositRecord, withdrawalRecord } from '@/api/payment'
import { gameBetRecord } from '@/api/game'
import { getTransaction } from '@/api/transaction'
import DepositHistory from '@/components/transaction-history/depositHistory'
import DepositHistoryMobile from '@/components/transaction-history/depositHistoryMobile'
import withdrawalHistory from '@/components/transaction-history/withdrawalHistory'
import WithdrawalHistoryMobile from '@/components/transaction-history/withdrawalHistoryMobile'
import BetHistory from '@/components/transaction-history/betHistory'
import OtherHistory from '@/components/transaction-history/otherHistory'
import TransactionHistoryModal from '@/components/modal/transactionHistoryModal'
import ScrollLoader from 'vue-scroll-loader/src/components/Scroll-Loader'

const API_MAP = {
  'depositRecord': depositRecord,
  'withdrawRecord': withdrawalRecord,
  'userBet': gameBetRecord,
  'bonus': getTransaction,
  'other': getTransaction
}

const ACTION_TYPES_CONFIG = {
  All: 'All',
  bonus: [
    { key: 'event', lang: 'Bao.bonus_type_event' },
    { key: 'rebate', lang: 'Bao.bonus_type_rebate' },
    { key: 'vip', lang: 'Bao.bonus_type_vip' },
    { key: 'system_recycle', lang: 'Bao.bonus_type_system_recycle' },
    { key: 'coupon', lang: 'Bao.bonus_type_coupon' }
  ],
  other: [
    { key: 'manual_deposit', lang: 'Bao.other_type_manual_deposit' },
    { key: 'manual_cost', lang: 'Bao.other_type_manual_cost' },
    { key: 'system_return', lang: 'Bao.other_type_system_return' },
    { key: 'reissue_add', lang: 'Bao.other_type_reissue_add' },
    { key: 'reissue_sub', lang: 'Bao.other_type_reissue_sub' },
    { key: 'transferBonusToMain', lang: 'Bao.other_type_transferBonusToMain' },
    { key: 'bonusSetZero', lang: 'Bao.other_type_bonusSetZero' },
    { key: 'wallet_transfer_in', lang: 'Bao.other_type_wallet_transfer_in' },
    { key: 'wallet_transfer_out', lang: 'Bao.other_type_wallet_transfer_out' }
  ]
}

export default {
  components: {
    datePicker,
    TransactionHistoryModal,
    ScrollLoader,
    DepositHistory,
    DepositHistoryMobile,
    withdrawalHistory,
    WithdrawalHistoryMobile,
    BetHistory,
    OtherHistory
  },
  data() {
    return {
      dateRange: {
        startDate: moment().subtract(7, 'd'),
        endDate: new Date()
      },
      type: null,
      actionType: [],
      record: [],
      page: 1,
      pageSize: 50,
      enableAutoLoad: false,
      loading: false,
      firstLoad: true,
      showHistory: false,
      selectedItem: {},
      beforeDay: 0,
      bonusActionTypes: ACTION_TYPES_CONFIG.bonus.map(item => item.key),
      otherActionTypes: ACTION_TYPES_CONFIG.other.map(item => item.key),
      selectedActionType: ACTION_TYPES_CONFIG.All,
      allProcessedList: [],
      datePickerKey: 0
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.processRouteType(to)
    })
  },
  beforeRouteUpdate(to, from, next) {
    this.processRouteType(to)
    next()
  },
  computed: {
    filteredActionOptions() {
      if (this.type !== 'bonus' && this.type !== 'other') {
        return []
      }

      const config = this.type === 'bonus' ? ACTION_TYPES_CONFIG.bonus : ACTION_TYPES_CONFIG.other

      const allOption = { key: ACTION_TYPES_CONFIG.All, lang: 'Bao.all' }
      return [allOption, ...config]
    }
  },
  created() {
    this.scrollToActive()
  },
  methods: {
    processRouteType(route) {
      const validTypes = ['depositRecord', 'withdrawRecord', 'userBet', 'bonus', 'other']
      const queryType = route.query.type
      const defaultType = 'depositRecord'
      let finalType = defaultType

      if (queryType && validTypes.includes(queryType)) {
        finalType = queryType
      }

      this.type = finalType

      this.oneQuery()
    },
    getWalletImagePath,
    async query() {
      if (this.loading) return
      this.loading = true
      this.firstLoad = false

      let queryObj = {}
      if (this.type === 'userBet') {
        queryObj.startDate = Math.floor(moment().subtract(this.beforeDay, 'days').startOf('day').valueOf() / 1000)
        queryObj.endDate = Math.floor(moment().subtract(this.beforeDay, 'days').endOf('day').valueOf() / 1000)
      } else {
        queryObj.startDate = moment(this.dateRange.startDate).format('YYYY/MM/DD')
        queryObj.endDate = moment(this.dateRange.endDate).format('YYYY/MM/DD')
      }

      queryObj = {
        'startDate': queryObj.startDate,
        'endDate': queryObj.endDate,
        'page': this.page,
        'page_size': this.pageSize
      }

      const apiMethod = API_MAP[this.type]
      if (!apiMethod) {
        console.error('Invalid type:', this.type)
        this.loading = false
        return
      }

      try {
        const res = await apiMethod(queryObj)
        const list = res.data.data.list || []
        if (this.type === 'depositRecord' || this.type === 'withdrawRecord') {
          this.queryDepositAndWithdrawal(list)
        } else if (this.type === 'userBet') {
          this.checkRecord(list)
        } else {
          this.processFilteredRecord(list)
        }
      } catch (error) {
        this.loading = false
        this.firstLoad = false
        this.enableAutoLoad = false
      }
    },
    queryDepositAndWithdrawal(list) {
      const processedList = list.map(item => {
        return {
          ...item,
          formattedTime: this.processedAndSplitDate(item.create_at),
          image: this.getWalletImagePath(item)
        }
      })

      this.record = [...this.record, ...processedList]
      if (list.length < this.pageSize) {
        this.enableAutoLoad = false
      } else {
        this.enableAutoLoad = true
        this.page += 1
      }
      this.loading = false

      this.$nextTick(() => {
        this.checkAndLoadMore()
      })
    },
    checkRecord(list) {
      const newRecordsMap = new Map()

      list.forEach(record => {
        const roundId = record.round_id && record.round_id.trim() ? record.round_id : null
        const walletType = record.wallet_type || ''

        // 組合唯一key
        const key = roundId ? `${roundId}_${walletType}` : null

        if (key) {
          if (!newRecordsMap.has(key)) {
            // 第一次出現
            newRecordsMap.set(key, {
              ...record,
              bet_amount: record.action_type === 'bet' ? record.amount : 0,
              win_amount: record.action_type === 'win' ? record.amount : 0,
              formattedTime: record.updated_at ? this.processedAndSplitDate(record.updated_at) : '-',
              image: this.getWalletImagePath(record)
            })
          } else {
            // 已經有這組key，合併
            const existingRecord = newRecordsMap.get(key)
            if (record.action_type === 'bet') {
              existingRecord.bet_amount = record.amount
            } else if (record.action_type === 'win') {
              existingRecord.win_amount = record.amount
            }
          }
        } else {
          // 沒有round_id，使用Symbol防止key衝突
          newRecordsMap.set(Symbol(), {
            ...record,
            bet_amount: record.action_type === 'bet' ? record.amount : 0,
            win_amount: record.action_type === 'win' ? record.amount : 0,
            image: this.getWalletImagePath(record)
          })
        }
      })

      const newRecords = Array.from(newRecordsMap.values())

      // 舊資料已存在的key集合
      const existingKeys = new Set(
        this.record
          .filter(r => r.round_id && r.round_id.trim())
          .map(r => `${r.round_id}_${r.wallet_type || ''}`)
      )

      // 過濾掉重複
      const filteredNewRecords = newRecords.filter(record => {
        const k = record.round_id ? `${record.round_id}_${record.wallet_type || ''}` : null
        if (k && existingKeys.has(k)) {
          return false
        }
        if (k) existingKeys.add(k)
        return true
      })

      // 合併到 this.record
      this.record = [...this.record, ...filteredNewRecords]

      // 目前的資料上限 (每次 scroll-loader 觸發時，允許的最大數量)
      const maxRecordsAllowed = 50 * this.page

      if (list.length < this.pageSize) {
        // **條件 1:** API 回傳數據 < pageSize，表示資料已撈完，停止自動載入
        this.enableAutoLoad = false
      } else if (this.record.length >= maxRecordsAllowed) {
        // **條件 2:** 如果目前記錄已達當前允許的最大數量，停止載入
        this.enableAutoLoad = false
      } else {
        // **條件 3:** 否則繼續下一頁
        this.page += 1
        this.enableAutoLoad = true
      }

      this.loading = false
      this.firstLoad = false

      this.$nextTick(() => {
        this.checkAndLoadMore()
      })
    },
    processFilteredRecord(list) {
      let rawFilteredList = []
      const currentActionConfig = ACTION_TYPES_CONFIG[this.type] || []
      const validActionKeys = currentActionConfig.map(opt => opt.key)

      rawFilteredList = list.filter(item => validActionKeys.includes(item.action_type))

      const processedList = rawFilteredList.map(item => {
        return {
          ...item,
          formattedTime: item.created_at ? this.processedAndSplitDate(item.created_at) : '-',
          image: this.getWalletImagePath(item)
        }
      })

      this.allProcessedList = [...this.allProcessedList, ...processedList]

      if (!this.selectedActionType) {
        this.selectedActionType = ACTION_TYPES_CONFIG.All
      }

      this.filterByActionType()

      // 先設定狀態
      if (list.length < this.pageSize) {
        this.enableAutoLoad = false
      } else {
        this.page += 1
        this.enableAutoLoad = true
      }

      this.loading = false
      this.firstLoad = false

      this.$nextTick(() => {
        this.checkAndLoadMore()
      })
    },
    filterByActionType() {
      if (this.selectedActionType === ACTION_TYPES_CONFIG.All) {
      // 如果是 All，則顯示所有已處理的資料 (即當前 type 的所有數據)
        this.record = this.allProcessedList
      } else {
      // 否則，根據選定的 actionType 過濾
        this.record = this.allProcessedList.filter(item =>
          item.action_type === this.selectedActionType
        )
      }
    },
    oneQuery() {
      this.page = 1
      this.enableAutoLoad = true
      this.record = []
      this.allProcessedList = []
      this.query()
    },
    processedAndSplitDate(formattedTime) {
      const formattedValue = this.$options.filters.fullDateTimeFormat(formattedTime)
      return formattedValue
    },
    hideHistoryModal() {
      this.showHistory = false
    },
    handleShowHistoryModal(item) {
      this.selectedItem = item
      this.showHistory = true
    },
    changeType(newType) {
      if (this.type === newType) return

      this.$router.push({
        path: this.$route.path,
        query: {
          ...this.$route.query,
          type: newType
        }
      }).catch(() => {})

      this.selectedActionType = ''
      this.allProcessedList = []
      this.dateRange = {
        startDate: moment().subtract(7, 'd'),
        endDate: new Date()
      }
      this.datePickerKey += 1

      this.scrollToActive()
    },
    switchDay(beforeDay) {
      this.beforeDay = beforeDay
      this.oneQuery()

      this.$nextTick(() => {
        const activeTab = document.querySelector('.NavTabs .btn-tertiary-2.active')
        if (activeTab) {
          activeTab.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'center'
          })
        }
      })
    },
    scrollToActive() {
      this.$nextTick(() => {
        setTimeout(() => {
          const container = this.$refs['tab']
          const activeItem = container.querySelector('.active')
          if (activeItem) {
            const containerRect = container.getBoundingClientRect()
            const activeItemRect = activeItem.getBoundingClientRect()

            let scrollPosition
            if (activeItem === container.lastElementChild) {
              scrollPosition = container.scrollWidth - container.clientWidth
            } else {
              scrollPosition = activeItemRect.left - containerRect.left + container.scrollLeft - (containerRect.width / 2) + (activeItemRect.width / 2)
            }

            container.scrollLeft = scrollPosition
          }
        }, 300)
      })
    },
    checkAndLoadMore() {
      // 1. 檢查：如果還可以載入更多資料
      if (!this.enableAutoLoad || this.loading) {
        return // 如果不能載入或正在載入，就不執行
      }

      // 2. 檢查：scroll-loader 的 loading UI 是否在可視範圍內
      const scrollLoaderElement = document.querySelector('.loader')
      if (scrollLoaderElement) {
        const rect = scrollLoaderElement.getBoundingClientRect()
        const isVisible = rect.top < window.innerHeight && rect.bottom >= 0

        // 3. 如果兩個條件都滿足，自動觸發載入
        if (isVisible) {
          this.query() // 自動觸發下一次載入
        }
      }
    }
  }
}
</script>
